import React, { FunctionComponent, useEffect, useState } from "react"
import { HeaderProps } from "./Header.models"
import { HeartIcon } from "../HeartIcon"
import {
  DesktopNavItem,
  Nav,
  NavigationItems,
  PersonalDetailsNav,
  SiteNav,
  SiteNavMobile,
  StyledClock,
  StyledHeader,
} from "./Header.styles"
import { Text } from "../Text/Text"
import { DarkModeIcon } from "../DarkModeIcon"
import { Link } from "../Link"

const Clock = () => {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date())
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <StyledClock>
      <Text as={"span"} variant={"body-3"}>
        {new Intl.DateTimeFormat("en-GB", {
          timeZone: "Europe/London",
          timeStyle: "long",
        }).format(time)}
      </Text>
    </StyledClock>
  )
}

export const Header: FunctionComponent<HeaderProps> = ({ siteTitle }) => (
  <>
    <StyledHeader>
      <Nav>
        <NavigationItems>
          <li>
            <PersonalDetailsNav>
              <li>
                <Link to="/" aria-label="Homepage">
                  <HeartIcon width={26} />
                </Link>
              </li>
              <li>
                <Link to="/">
                  <Text as={"span"} variant={"body-1"}>
                    Mali Coxon
                  </Text>
                </Link>
              </li>
              <li>
                <Text as={"span"} variant={"body-1"}>
                  •
                </Text>
              </li>
              <li>
                <Text as={"span"} variant={"body-1"}>
                  <em>London, UK</em>
                </Text>
              </li>
              <li>
                <Clock />
              </li>
            </PersonalDetailsNav>
          </li>
          <li>
            <SiteNav>
              <DesktopNavItem>
                <Link to="/">
                  <Text as={"span"} variant={"body-1"}>
                    Projects
                  </Text>
                </Link>
              </DesktopNavItem>
              <DesktopNavItem>
                <Link to="/blog/" partiallyActive={true}>
                  <Text as={"span"} variant={"body-1"}>
                    Blog
                  </Text>
                </Link>
              </DesktopNavItem>
              <DesktopNavItem>
                <Link to="/about/">
                  <Text as={"span"} variant={"body-1"}>
                    About / Contact
                  </Text>
                </Link>
              </DesktopNavItem>
              <li>
                <DarkModeIcon size={12} />
              </li>
            </SiteNav>
          </li>
        </NavigationItems>
      </Nav>
    </StyledHeader>
    <SiteNavMobile>
      <li>
        <Link to="/">
          <Text as={"span"} variant={"body-1"}>
            Projects
          </Text>
        </Link>
      </li>
      <li>
        <Link to="/blog/" partiallyActive={true}>
          <Text as={"span"} variant={"body-1"}>
            Blog
          </Text>
        </Link>
      </li>
      <li>
        <Link to="/about/">
          <Text as={"span"} variant={"body-1"}>
            About
          </Text>
        </Link>
      </li>
    </SiteNavMobile>
  </>
)
